// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("./IconV5.bs.js");
let Tooltip = require("./Tooltip.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("./FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UnselectedUnionMemberError = require("../ErrorHandling/UnselectedUnionMemberError.bs.js");
let UseShouldShowPropertyDetails = require("../Hooks/UseShouldShowPropertyDetails.bs.js");
let AgentPropertyLocation_property_graphql = require("../../../__generated__/AgentPropertyLocation_property_graphql.bs.js");
let AgentPropertyLocation_propertyLocation_graphql = require("../../../__generated__/AgentPropertyLocation_propertyLocation_graphql.bs.js");

let convertFragment = AgentPropertyLocation_property_graphql.Internal.convertFragment;

let convertFragment$1 = AgentPropertyLocation_propertyLocation_graphql.Internal.convertFragment;

let hiddenAddressLine = "flex flex-row items-center lg:before:content-['('] lg:after:content-[')'] before:content-none after:content-none";

function AgentPropertyLocation$Address(props) {
  let visibilityRule = props.visibilityRule;
  let locationDisplay = props.locationDisplay;
  let address = props.address;
  let tmp;
  if (address !== undefined) {
    let exit = 0;
    if (visibilityRule !== undefined) {
      let exit$1 = 0;
      if (visibilityRule === "VISIBLE_TO_ACCOUNT_MEMBER" || visibilityRule === "VISIBLE_TO_TAN_STAFF" || visibilityRule === "VISIBLE_TO_ALL") {
        switch (visibilityRule) {
          case "VISIBLE_TO_ALL" :
            exit = 1;
            break;
          case "VISIBLE_TO_ACCOUNT_MEMBER" :
          case "VISIBLE_TO_TAN_STAFF" :
            exit$1 = 2;
            break;
        }
      } else {
        exit = 1;
      }
      if (exit$1 === 2) {
        let tmp$1;
        if (visibilityRule === "VISIBLE_TO_ACCOUNT_MEMBER" || visibilityRule === "VISIBLE_TO_TAN_STAFF" || visibilityRule === "VISIBLE_TO_ALL") {
          switch (visibilityRule) {
            case "VISIBLE_TO_ACCOUNT_MEMBER" :
              tmp$1 = " (only visible to you)";
              break;
            case "VISIBLE_TO_ALL" :
              tmp$1 = "";
              break;
            case "VISIBLE_TO_TAN_STAFF" :
              tmp$1 = " (visible to TAN staff)";
              break;
          }
        } else {
          tmp$1 = "";
        }
        tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx("div", {
              children: locationDisplay
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(IconV5.make, {
                    icon: "lock",
                    size: 16,
                    className: "text-zinc-600 mr-1"
                  }),
                  JsxRuntime.jsx(Tooltip.make, {
                    label: address + tmp$1,
                    children: JsxRuntime.jsx("div", {
                      children: "Hidden Address",
                      className: "border-dotted border-b border-zinc-400"
                    })
                  })
                ],
                className: hiddenAddressLine
              }),
              className: "text-zinc-600 text-lg"
            })
          ]
        });
      }
    } else {
      exit = 1;
    }
    if (exit === 1) {
      tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          JsxRuntime.jsx("div", {
            children: address
          }),
          JsxRuntime.jsx("div", {
            children: locationDisplay,
            className: "text-zinc-600 text-lg"
          })
        ]
      });
    }
  } else {
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx("div", {
          children: locationDisplay
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(IconV5.make, {
                icon: "lock",
                size: 16,
                className: "text-zinc-600 mr-1"
              }),
              JsxRuntime.jsx("div", {
                children: "Hidden Address"
              })
            ],
            className: hiddenAddressLine
          }),
          className: "text-zinc-600 text-lg"
        })
      ]
    });
  }
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("div", {
      children: tmp,
      className: "flex flex-col gap-2 lg:gap-2 lg:flex-row items-baseline"
    }),
    className: "text-zinc-700 font-medium text-2xl lg:text-3xl"
  });
}

function AgentPropertyLocation$ProPlanLabel(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "bg-tan-gold text-white px-2 py-1 text-base rounded font-semibold"
  });
}

function AgentPropertyLocation$AddressFreePlan(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
          children: props.locationDisplay
        }),
        className: "text-zinc-700 font-medium text-2xl lg:text-3xl"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: "Address",
            className: "text-zinc-500 tracking-wide  font-medium uppercase"
          }),
          JsxRuntime.jsx(AgentPropertyLocation$ProPlanLabel, {
            children: "Pro Plan Only"
          })
        ],
        className: "flex gap-1 flex-col items-baseline"
      })
    ],
    className: "flex flex-col gap-2"
  });
}

function AgentPropertyLocation$ByPropertyLocation(props) {
  let propertyLocation = RescriptRelay_Fragment.useFragment(AgentPropertyLocation_propertyLocation_graphql.node, convertFragment$1, props.propertyLocation);
  if (props.shouldShowPropertyDetails) {
    switch (propertyLocation.__typename) {
      case "PropertyLocationWithHiddenAddress" :
        return JsxRuntime.jsx(AgentPropertyLocation$Address, {
          address: undefined,
          locationDisplay: propertyLocation.locationDisplay
        });
      case "PropertyLocationWithVisibleAddress" :
        return JsxRuntime.jsx(AgentPropertyLocation$Address, {
          address: propertyLocation.address,
          locationDisplay: propertyLocation.locationDisplay,
          visibilityRule: propertyLocation.visibilityRule
        });
      case "__unselected" :
        break;
    }
  } else {
    switch (propertyLocation.__typename) {
      case "PropertyLocationWithHiddenAddress" :
        return JsxRuntime.jsx(AgentPropertyLocation$AddressFreePlan, {
          locationDisplay: propertyLocation.locationDisplay
        });
      case "PropertyLocationWithVisibleAddress" :
        return JsxRuntime.jsx(AgentPropertyLocation$AddressFreePlan, {
          locationDisplay: propertyLocation.locationDisplay
        });
      case "__unselected" :
        break;
    }
  }
  return UnselectedUnionMemberError.raise(`Unselected property location ` + propertyLocation._0);
}

let ByPropertyLocation = {
  make: AgentPropertyLocation$ByPropertyLocation
};

function AgentPropertyLocation$ProjectAddressLine(props) {
  let propertyLocation = RescriptRelay_Fragment.useFragment(AgentPropertyLocation_propertyLocation_graphql.node, convertFragment$1, props.propertyLocation);
  let text;
  switch (propertyLocation.__typename) {
    case "PropertyLocationWithHiddenAddress" :
      text = propertyLocation.locationDisplay;
      break;
    case "PropertyLocationWithVisibleAddress" :
      text = propertyLocation.address + `, ` + propertyLocation.locationDisplay;
      break;
    case "__unselected" :
      text = "";
      break;
  }
  if (text === "") {
    return null;
  } else {
    return JsxRuntime.jsx("div", {
      children: text,
      className: "text-zinc-600"
    });
  }
}

let ProjectAddressLine = {
  make: AgentPropertyLocation$ProjectAddressLine
};

function AgentPropertyLocation$WithoutErrorBoundary(props) {
  let property = RescriptRelay_Fragment.useFragment(AgentPropertyLocation_property_graphql.node, convertFragment, props.property);
  let shouldShowPropertyDetails = UseShouldShowPropertyDetails.use(property.fragmentRefs);
  return JsxRuntime.jsx(AgentPropertyLocation$ByPropertyLocation, {
    propertyLocation: property.propertyLocation.fragmentRefs,
    shouldShowPropertyDetails: shouldShowPropertyDetails
  });
}

let WithoutErrorBoundary = {
  make: AgentPropertyLocation$WithoutErrorBoundary
};

function AgentPropertyLocation(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "location",
    children: JsxRuntime.jsx(AgentPropertyLocation$WithoutErrorBoundary, {
      property: props.property
    })
  });
}

let make = AgentPropertyLocation;

exports.ByPropertyLocation = ByPropertyLocation;
exports.ProjectAddressLine = ProjectAddressLine;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* IconV5 Not a pure module */
